import Popover from './Popover'

export default Popover



// WEBPACK FOOTER //
// ./src/legacy/containers/Popovers/components/Popover/index.js